<app-navbar-wrapper>
  <ng-container navbar-left-side>
    <div
      class="navbar-image mx-0"
      app-logo
    ><!-- Logo SVG is added through `app-logo` attribute component --></div>
    @if (!isUserOnLeave) {
      <div class="ms-3 d-flex align-items-center h-100">
        @for (navElement of elements; track navElement) {
          <a
            [routerLink]="getRouterLinkPath(navElement)"
            [class.active]="isActive(navElement)"
            (click)="onClick(navElement)"
            class="nav-link"
          >
            {{ navElement.title | translate }}
          </a>
        }
      </div>
    }
  </ng-container>

  <ng-container navbar-right-side>
    <ul class="h-100 d-flex align-items-center list-unstyled m-0 p-0">
      @if (!isUserOnLeave) {
        <li class="nav-item nav-icon mx-0 px-0"
          *permissionsElementVisibilityDecisionMaker="[permissionActions.CAN_CHANGE_PRICELIST]"
        >
          <app-drop-down [data]="priceList"
            cssClasses="d-flex"
            class="d-flex"
            linkCssClasses="p-3 color-gray-400 cursor-pointer hover-color-white"
            appActivatePricelist
          />
        </li>
        <li class="nav-item nav-icon mx-0 px-0">
          <button class="btn btn-default nav-link px-3 border-0" (click)="onNotificationsModalOpen()" [title]="'NAVBAR.TOOLTIPS.NOTIFICATIONS' | translate">
            <i class="icon ni-notification-bell">
              <app-notification [notifications]="user?.unseenNotifications" />
            </i>
          </button>
        </li>
        <li class="nav-item nav-icon mx-0 px-0">
          <button class="btn btn-default nav-link px-3 border-0" (click)="onMessagesModalOpen()" [title]="'NAVBAR.TOOLTIPS.COMMUNICATION' | translate">
            <i class="icon ni-chat-square-plain">
              <app-notification [notifications]="user?.unreadMessages" />
            </i>
          </button>
        </li>
        <li class="nav-item nav-icon">
          <a class="btn btn-default nav-link px-3 border-0" [routerLink]="generalRoutePaths.FAQ" [title]="'NAVBAR.TOOLTIPS.FAQ' | translate">
            <i class="icon ni-faq"></i>
          </a>
        </li>
      }
      <li class="nav-item nav-icon d-none d-sm-block">
        <app-language-switch />
      </li>
      <li class="nav-item nav-icon d-none d-sm-block">
        <app-unimpersonate />
      </li>
      <li #userDropdown="ngbDropdown"
        ngbDropdown
        autoClose="outside"
        placement="bottom-end"
        class="nav-item user pe-0"
      >
        <button
          ngbDropdownToggle
          class="btn btn-default px-0 nav-link d-flex align-items-center h-100 no-underline no-outline bg-black hover-bg-black"
          [ngClass]="{ 'sale-mode': saleMode, 'deep-hover-color-white': !saleMode }"
        >
          <div
            class="d-flex rounded-pill align-items-center ps-3 pe-1 py-1 deep-hover"
            [ngClass]="userBadgeClasses"
          >
            <span>
              {{ user?.firstName || user?.email }}
            </span>
            <img
              [src]="user?.profilePicture ? (user.profilePicture.url | resizeImage: imageSizes.SIZE_64x64) : 'assets/images/user/user@2x.png'"
              alt=""
              class="user__image"
            />
          </div>
        </button>
        <div ngbDropdownMenu class="shadow p-0 dropdown-menu-end">
          <app-list-mode-switch *permissionsElementVisibilityDecisionMaker="[permissionActions.CAN_SWITCH_LIST_MODES]"
           />
          <a
            class="dropdown-item btn btn-secondary text-nowrap d-flex border-top rounded-0"
            routerLink="/user/sale-coefficients"
            *permissionsElementVisibilityDecisionMaker="[permissionActions.CAN_CHANGE_SALE_COEFFICIENTS]"
            (click)="userDropdown.close()"
          >
            <i class="icon ni-discount me-3"></i>
            <span>{{ 'SALE_COEFFICIENTS.SALE_COEFFICIENTS' | translate }}</span>
          </a>
          @if (!isUserOnLeave) {
            <a
              class="dropdown-item btn btn-secondary text-nowrap d-flex border-top rounded-0"
              routerLink="/user/settings"
              (click)="userDropdown.close()"
            >
              <i class="icon ni-settings me-3"></i>
              <span>{{ 'SETTINGS.TITLE' | translate }}</span>
            </a>
          }
          @if (isDealerAdmin) {
            <a
              class="dropdown-item btn btn-secondary text-nowrap d-flex border-top rounded-0"
              [routerLink]="generalRoutePaths.MANAGED_USERS"
              (click)="userDropdown.close()"
              data-testid="managedUserNavElement"
            >
              <i class="icon ni-admin me-3"></i>
              <span>{{ 'MANAGED_USERS.MANAGE_USERS' | translate }}</span>
            </a>
          }
          @if (hasPermissionToViewCompanyProfile && (isDealer || isNarbutasLT)) {
            <a
              class="dropdown-item btn btn-secondary text-nowrap d-flex border-top rounded-0"
              [routerLink]="generalRoutePaths.COMPANY_ACCOUNT"
              (click)="userDropdown.close()"
            >
              <i class="icon ni-business me-3"></i>
              <span>{{ 'COMPANY_ACCOUNT.TITLE' | translate }}</span>
            </a>
          }
          @if (showLeaveAndCoverageNavElement) {
            <a
              class="dropdown-item btn btn-secondary text-nowrap d-flex border-top"
              [routerLink]="[generalRoutePaths.LEAVE_AND_COVERAGE, leaveAndCoverageTabs.COVER_COLLEAGUES]"
              (click)="userDropdown.close()"
              data-testid="leaveAndCoverageNavElement"
            >
              <i class="icon ni-outbound me-3"></i>
              <span>{{ 'LEAVE_AND_COVERAGE.TITLE' | translate }}</span>
            </a>
          }
          @if (!isUserOnLeave) {
            <a
              class="dropdown-item btn btn-secondary text-nowrap d-flex border-top rounded-0"
              routerLink="/terms"
              (click)="userDropdown.close()"
            >
              <i class="icon ni-privacy me-3"></i>
              <span>{{ 'TERMS.PRIVACY_AND_TERMS' | translate }}</span>
            </a>
          }
          @if (isCoveringActive) {
            <a
              class="dropdown-item btn btn-secondary text-nowrap d-flex border-top"
              (click)="onStopCovering(); userDropdown.close()"
            >
              <i class="icon ni-outbound me-3"></i>
              <span>{{ 'LEAVE_AND_COVERAGE.STOP_COVERING' | translate }}</span>
            </a>
          } @else {
            <a
              class="dropdown-item btn btn-secondary text-nowrap d-flex border-top"
              (click)="onLogout(); userDropdown.close()"
            >
              <i class="icon ni-logout-bracket me-3"></i>
              <span>{{ 'USER.LOGOUT' | translate }}</span>
            </a>
          }
        </div>
      </li>
    </ul>
  </ng-container>
</app-navbar-wrapper>
